// Main.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import LoadingSpinner from '../../LoadingSpinner';
import { useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import './Main.css';

function Main() {

   
    const navigate = useNavigate(); // Initialize useNavigate
    const [notification, setNotification] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
  
    const [isArithmeticQuiz, setIsArithmeticQuiz] = useState(false);
    const [isLanguage, setIsLanguage] = useState(false);
    const [isDrawings, setIsDrawings] = useState(false);
    const [isMemoryGames, setIsMemoryGames] = useState(false);
    const [isPuzzles, setIsPuzzles] = useState(false);
   

    const toggleSection = (section) => {
        if (section === 'ArithmeticQuiz') {
          setIsArithmeticQuiz(!isArithmeticQuiz);
        } else if (section === 'Language') {
          setIsLanguage(!isLanguage);
        } else if (section === 'Drawings') {
          setIsDrawings(!isDrawings);
        } else if (section === 'MemoryGames') {
          setIsMemoryGames(!isMemoryGames);
        } else if (section === 'Puzzles') {
          setIsPuzzles(!isPuzzles);    
        }
        
      };
    
    
      const renderIcon = (section) => {
        if (section === 'ArithmeticQuiz') {
          return isArithmeticQuiz ? '' : '' /* or '-' : '+'*/;
        } else if (section === 'Language') {
          return isLanguage ? '' : '' /* or '-' : '+'*/;
        } else if (section === 'Drawings') {
          return isDrawings ? '' : '' /* or '-' : '+'*/;
        } else if (section === 'MemoryGames') {
          return isMemoryGames ? '' : '' /* or '-' : '+'*/;
        } else if (section === 'Puzzles') {
          return isPuzzles ? '' : '' /* or '-' : '+'*/;   
        }
      };

      const GeneralArithmeticQuiz = () => {
        navigate('/general-arithmetic-quiz');
      };

      const GeneralPronunciation = () => {
        navigate('/general-pronunciation');
      };

      const Dictionary = () => {
        navigate('/dictionary');
      };
      
      const Drawings = () => {
        navigate('/drawing-board');
      };
      

      const MemoryGames = () => {
        navigate('/memory-game');
      };

      const PuzzleGame = () => {
        navigate('/puzzle-game');
      };
    
      return (
        <div>
    
          <div className="parent-container">
            {isLoading && <LoadingSpinner />}
            {!isLoading && (
              <>
                <div className="settings-container">
              
            <div className="column-three-account-settings">
             
             
             
            </div>
                
                  
                  {/* User Info */}
                  <div className="card">
                    <div onClick={() => toggleSection('ArithmeticQuiz')} className="card-title">
                      <Icon icon="mynaui:math-square-solid" color="black" width="40" height="40" style={{ marginRight: '10px' }} />
                      Arithmetic Quiz {renderIcon('ArithmeticQuiz')} 
                    </div>
                    {isArithmeticQuiz && (
                      <>
                     
    
    
   
                        <ul>
                       
                         
                     
                        </ul>
                        <button onClick={GeneralArithmeticQuiz} >General Arithmetic Quiz</button>
                      </>
                    )}
                  </div>

                  <div className="card">
                    <div onClick={() => toggleSection('MemoryGames')} className="card-title">
                      <Icon icon="arcticons:memory-zone" color="black" width="40" height="40" style={{ marginRight: '10px' }} />
                      Memory Games {renderIcon('MemoryGames')}
                    </div>
                    {isMemoryGames && (
                      <>
                      
                       
                        <p>
                        <button onClick={MemoryGames} >Memory Game</button>
                        </p>
                      </>
                    )}
                  </div>

                  <div className="card">
                    <div onClick={() => toggleSection('Puzzles')} className="card-title">
                      <Icon icon="fluent:puzzle-cube-28-filled" color="black" width="40" height="40" style={{ marginRight: '10px' }} />
                      Puzzle Games {renderIcon('Puzzles')}
                    </div>
                    {isPuzzles && (
                      <>
                      
                       
                        <p>
                        <button onClick={PuzzleGame} >Puzzle Game</button>
                        </p>
                      </>
                    )}
                  </div>
    
                  <div className="card">
                    <div onClick={() => toggleSection('Drawings')} className="card-title">
                      <Icon icon="pepicons-pencil:paint-pallet-circle-filled" color="black" width="40" height="40" style={{ marginRight: '10px' }} />
                      Drawings {renderIcon('Drawings')}
                    </div>
                    {isDrawings && (
                      <>
                      
                       
                        <p>
                        <button onClick={Drawings} >Drawings</button>
                        </p>
                      </>
                    )}
                  </div>



                  <div className="card">
                    <div onClick={() => toggleSection('Language')} className="card-title">
                      <Icon icon="healthicons:speech-language-therapy" color="black" width="60" height="60" style={{ marginRight: '5px' }} />
                      Language Tools{renderIcon('Language')}
                    </div>
                    {isLanguage && (
                      <>
                       
                        <div>
                          
                        <button onClick={GeneralPronunciation} >General Pronunciation</button>
                        
                        </div>


                        <div><button onClick={Dictionary} >Simplified Dictionary</button></div>
                      </>
                    )}
                  </div>
    
                 
                 
                  
                </div>
              </>
            )}
            
          </div>
          
        </div>
      );
}

export default Main;
